
import { mapState, mapGetters } from 'vuex'
import cms from '~/mixins/common/cms'
export default {
    name: 'NavBar',
    mixins: [cms],
    data: () => ({
        drawer: false,
        hostname: null,
        gameIndex: null,
    }),
    computed: {
        ...mapState({
            isLogin: (state) => state.settings.isLogin,
            player: (state) => state.player.player,
            menubars: (state) => state.cms.menus.menus,
        }),
        ...mapGetters({
            headerLogo: 'cms/headerLogo',
        }),
    },
    watch: {
        '$route.query.idx'(value) {
            this.gameIndex = value
        },
        menubars(value) {
            if (this.$route.query.idx) return
            this.gameIndex = value.length + 1
        },
    },
    mounted() {
        this.hostname = window.location.hostname
        if (this.$route?.query?.idx) {
            this.gameIndex = this.$route.query?.idx
        }
        if (this.isMobileOnly())
            this.$store.dispatch('cms/cmsComponentCode', {
                platform: 2,
                component_code: 'HeaderLogo',
            })
    },
    methods: {},
}
